var classes = {"root":"x2VyJ","spacerSizeNone":"RKbVl","spacerSizeXS":"B90g0","spacerSizeS":"_6SiQS","spacerSizeM":"VkwB2","spacerSizeL":"_9OLrI","spacerSizeXL":"a9aaf"};

export { classes as default };
